import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLazyGetCartDetailsByIdQuery } from "../../../../redux/services/cartSearchService";
import { useLazyGetRestaurantDetailsByIdQuery } from "../../../../redux/services/restaurantSearchService";
import DataTable, { TableColumn } from "react-data-table-component";
import { useSelector } from "react-redux";
import ViewButtonComponent from "../../../../components/ViewButtonComponent";
import TableLoadingComponent from "../../../../components/TableLoadingComponent";

const Inventory = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const cart = useSelector((state: any) => state?.cart?.selectedCart);
  const cartId = cart.id || cart.cartId;
  const [triggerCartDetails, { data: cartData, isLoading: isFetching }] =
    useLazyGetCartDetailsByIdQuery();

  const [
    triggerRestaurantDetails,
    {
      isLoading: isRestaurantDataLoading,
    },
  ] = useLazyGetRestaurantDetailsByIdQuery();

  const [restaurants, setRestaurants] = useState([]);

  useEffect(() => {
    if (cart.id) {
      triggerCartDetails(cart.id);
    }
    if (cart.cartId) {
      triggerCartDetails(cart.cartId);
    }
  }, [cart.id, triggerCartDetails, cart.cartId]);

  useEffect(() => {
    if (cartData?.restaurantIds) {
      setIsLoading(true);
      const fetchRestaurantDetails = async () => {
        const restaurantDetails: any = await Promise.all(
          (cartData.restaurantIds).map(async (id: any) => {
            const response = await triggerRestaurantDetails(id).unwrap();
            return response;
          })
        );
        setRestaurants(restaurantDetails);
        setIsLoading(false);
      };

      fetchRestaurantDetails();
    }
  }, [cartData?.restaurantIds, triggerRestaurantDetails, cart?.restaurantIds]);


  const handleInventoryView = (restaurantId: string, cartId: string) => {
    navigate("/carts/carts-list/view/inventory-view", {
      state: { restaurantId, cartId },
    });
  };

  const columns: TableColumn<any>[] = [
    {
      name: <div style={{ fontSize: "15px", fontWeight: "bold" }}>Image</div>,
      cell: (row) => (
        <img
          src={row.restaurant.imageUrl}
          alt="restaurantimage"
          width="50px"
          height="40px"
          style={{ borderRadius: "10px" }}
        />
      ),
    },
    {
      name: (
        <div style={{ fontSize: "15px", fontWeight: "bold" }}>
          Restaurant Name
        </div>
      ),
      cell: (row) => (
        <div style={{ fontSize: "14px" }}>{row.restaurant.displayName}</div>
      ),
      sortable: true,
    },
    {
      name: <div style={{ fontSize: "15px", fontWeight: "bold" }}>Address</div>,
      cell: (row) => (
        <div style={{ fontSize: "14px" }}>{row.restaurant.address}</div>
      ),
      sortable: true,
    },
    {
      name: <div style={{ fontSize: "15px", fontWeight: "bold" }}>Action</div>,
      selector: (row) => "action",
      cell: (row) => (
        <div className="d-flex gap-2">
          <ViewButtonComponent
            onClick={() => handleInventoryView(row.restaurant.id, cartId)}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  return (
    <>
      {isFetching || isRestaurantDataLoading || isLoading ? (
        <TableLoadingComponent numColumns={4} />
      ) : (
        <div className="m-4">
          <DataTable columns={columns} data={restaurants} pagination noDataComponent={<div>No Inventory Details found</div>} />
        </div>
      )}
    </>
  );
};

export default Inventory;
